import PropTypes from "prop-types";
import React, { Component } from "react";

import { Waypoint } from "react-waypoint";

import Button from "components/Button";
import CampaignCard from "components/CampaignCard";
import CampaignListing from "components/CampaignListing";

import "./_style.scss";

class Results extends Component {
  static propTypes = {
    campaigns: PropTypes.array,
    isLoading: PropTypes.bool,
    isLoadingMore: PropTypes.bool,
    loadingMessage: PropTypes.string,
    hasMoreResults: PropTypes.string,
    onLoadMore: PropTypes.func,
  };

  static defaultProps = {
    isLoading: false,
    isLoadingMore: true,
    campaigns: [],
    onLoadMore: () => {},
    loadingMessage: "Loading results ...",
  };

  state = {
    hasBeenClickedOnce: false,
    doInfinityScrolling: false,
  };

  UNSAFE_componentWillReceiveProps() {
    const {
      hasBeenClickedOnce,
    } = this.state;

    if (hasBeenClickedOnce) {
      this.setState({
        doInfinityScrolling: true,
      });
    }
  }

  loadMoreHandler = () => {
    const {
      onLoadMore,
    } = this.props;

    this.setState({
      hasBeenClickedOnce: true,
    });

    onLoadMore();
  };

  render() {
    const {
      campaigns,
      hasMoreResults,
      isLoading,
      isLoadingMore,
      onLoadMore,
    } = this.props;

    const {
      doInfinityScrolling,
    } = this.state;

    return (
      <div className="browse-results">
        {!campaigns.length
          && (
            <div className="browse-results__no-results">
              <h1>Sorry but we could not find any matching campaigns</h1>
              <p>
                But you can
                {" "}
                <a href="/onboarding">start your own</a>
                !
              </p>
            </div>
          )}
        <CampaignListing isLoading={isLoading}>
          {
            campaigns.map((campaign, i) => (
              <CampaignCard
                key={`${i}${campaign.title}}`}
                campaign={campaign}
              />
            ))
          }
        </CampaignListing>
        {(hasMoreResults && !doInfinityScrolling)
          && (
          <Button
            className="loadMore"
            isLoading={isLoadingMore}
            onClick={this.loadMoreHandler}
            look="primary"
          >
            Load more
          </Button>
          )}
        {(hasMoreResults && doInfinityScrolling)
          && (
          <Waypoint
            bottomOffset="60px"
            scrollableAncestor={window}
            onEnter={onLoadMore}
          />
          )}
      </div>
    );
  }
}

export default Results;
